
import apiInstance from '../utils/apiInstance';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Table from '../common/Table';

const MenuItems = () => {
    const { _id } = useParams();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sortedData, setSortedData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await apiInstance.get(`/menuItems/${_id}`);
                setData(response.data.menuItems);
            } catch (error) {
                setError("An error occurred while fetching menu items...");
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [_id]);

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const sorted = [...data].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setSortedData(sorted);
        }
    }, [data]);
    const filteredData = sortedData.filter(menuItem =>
        menuItem?.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        menuItem?.category?.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (menuItem?.price && menuItem?.price.toString().includes(searchQuery))
    );

    const options = ['S No.', 'Image', 'Name', 'Category', 'Price', 'Availability', 'Actions'];

    if (error) return <div>{error}<br />Please try again after some time or check your internet connection.</div>;

    return (
        <>
            <Table
                menu='menu'
                heading='Menu Items'
                options={options}
                data={filteredData}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                loading={loading}
            />
            {loading && (
                <div className="loader" style={{ position: 'absolute', top: '50%', left: '59%', transform: 'translate(-50%, -50%)' }}>
                    <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default MenuItems;